module.exports = __webpack_public_path__ + "static/media/nav-icon--tickets.be7b2155.svg";